var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17.7631H3.83333C3.36662 17.7631 3.13327 17.7631 2.95501 17.6722C2.79821 17.5923 2.67072 17.4649 2.59083 17.3081C2.5 17.1298 2.5 16.8964 2.5 16.4297V2.76306M16.6667 12.7631L13.4009 9.27751C13.2772 9.14542 13.2153 9.07937 13.1406 9.04523C13.0747 9.0151 13.0021 9.00267 12.93 9.00917C12.8482 9.01654 12.7679 9.05825 12.6072 9.14167L9.89277 10.5511C9.73212 10.6345 9.65179 10.6762 9.57003 10.6836C9.49787 10.6901 9.42526 10.6777 9.35936 10.6476C9.28471 10.6134 9.22282 10.5474 9.09906 10.4153L5.83333 6.92973",
    stroke: "#667185",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.9a5e11a11ff11009a616c452c75f6704.svg";
export { ForwardRef as ReactComponent };